module.exports = __webpack_public_path__ + "media/images/signalement-564c499159755bee8c37655c7e3b239d.jpg";